export default "<p>auto-generated works!</p>\r\n"